// @ts-check
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import SimpleTable, { RowSelection } from 'components/Common/SimpleTable/SimpleTable';
import { closeButton } from './ModalButtons';
import styles from './SelectedResourcesModal.module.css';
import { createRelation } from 'components/Admin/Organizations/Relations/GroupRelationTable';
import { ResourceRelationLevel } from 'utils/types';
import T from 'localization/LocalizationKeys';

const defaultGlobalActions = (selected, groupId, updateRelationsFn) => {
  return [
    {
      label: T.permissions.member,
      onClick: () => {
        const relations = selected.map((row) => {
          return createRelation(groupId, row.id, ResourceRelationLevel.member, row.type);
        });
        updateRelationsFn(relations);
      }
    },
    {
      label: T.permissions.manager,
      onClick: () => {
        const relations = selected.map((row) => {
          return createRelation(groupId, row.id, ResourceRelationLevel.manager, row.type);
        });
        updateRelationsFn(relations);
      }
    },
    {
      label: T.permissions.owner,
      onClick: () => {
        const relations = selected.map((row) => {
          return createRelation(groupId, row.id, ResourceRelationLevel.owner, row.type);
        });
        updateRelationsFn(relations);
      }
    }
  ];
};

/**
 *
 * @prop {*} props TODO: add props
 * @returns {React.ReactElement}
 */
const SelectUsersModal = ({ title, tableColumns, isOpen, onClose, available, groupId, updateRelationsFn, globalActionsArray = defaultGlobalActions }) => {
  const T = useTranslation();
  const [selected, setSelected] = useState([]);

  const _onClose = useCallback(() => {
    setSelected(null);
    onClose();
  }, [onClose]);

  const globalActions = useCallback((selected) => {
    return globalActionsArray(selected, groupId, updateRelationsFn);
  }, [globalActionsArray, groupId, updateRelationsFn]);

  return (
    // @ts-ignore-next-line
    <Modal
      variant={ModalVariant.medium}
      className={styles.selectionModal}
      title={title}
      isOpen={isOpen}
      onClose={_onClose}
      actions={closeButton({ T, onClose: _onClose })}
    >
      <SimpleTable
        globalActions={globalActions(selected)}
        data={available}
        columns={tableColumns}
        rowSelection={RowSelection.MULTI_CHECKBOX}
        selectedRows={selected}
        onSelectedRows={setSelected}
      />
    </Modal>
  );
};

export default SelectUsersModal;
